<!--
 * @Author: your name
 * @Date: 2021-08-16 18:44:07
 * @LastEditTime: 2024-10-30 14:56:15
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\explorer\NewMediaList\File.vue
-->
<template>
  <div class="file-item" ref="fileBox">
    <div class="file-img flex-c-c" @dblclick="openFile" ref="fileComponents">
      <img class="m-img" :src="imageRequire(file.group_dir?'fileLock':'file')" alt />
      <div class="f-select" :class="{'f-select-a':fileChecked}" v-show="file.group_dir === 0">
        <el-checkbox v-model="fileChecked" @change="checkboxChange"></el-checkbox>
      </div>
      <ul class="f-menu-list flex-d-a-c" v-show="isMenuList">
        <li class="f-m-l-item" @click="handleFile('move')">{{$t('explorer.move')}}</li>
        <!-- <li class="f-m-l-item" @click="handleFile('share')">分享</li> -->
        <li class="f-m-l-item" @click="handleFile('copy')">{{$t('explorer.copy')}}</li>
        <li class="f-m-l-item" @click="handleFile('del')">{{$t('explorer.delete')}}</li>
      </ul>
    </div>
    <template v-if="file.group_dir === 0">
      <div
        v-if="activeName"
        @dblclick="inputAction"
        class="file-title file-title-text ellipsis-1"
        :title="file.name"
      >{{file.name}}</div>
      <div v-else>
        <input ref="inputEle" class="input-name" @blur="blur" v-model="fileVal" />
      </div>
    </template>
    <template v-else>
      <div class="file-title ellipsis-1" :title="file.name">※{{file.name}}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'File',
  props: {
    file: {
      type: Object,
      required: true,
      default: () => { }
    },
    isSelected: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      fileVal: "文件名",
      activeName: true,
      fileChecked: false,
      isMenuList: false,
      mousePoint: {
        x: 0,
        y: 0
      }
    }
  },
  created() {
    this.fileChecked = this.isSelected;
  },
  mounted() {
    // console.log(this.file)
    this.$refs.fileComponents.oncontextmenu = (e) => {
      e.preventDefault();
    };
    this.file.group_dir === 0 && this.setOnMouseRight();
  },
  methods: {
    setOnMouseRight() {
      this.$refs.fileComponents.onmousedown = (e) => {
        if (e.button == 2) {
          // alert("你点了右键");
          this.mousePoint.x = e.offsetX;
          this.mousePoint.y = e.offsetY;
          this.isMenuList = true;
          console.log(e);
        } else if (e.button == 0) {
          // alert("你点了左键");
          console.log(e)
        } else if (e.button == 1) {
          // alert("你点了滚轮");
          console.log(e)
        }
      }
      this.$refs.fileBox.onmouseleave = () => {
        // e.stopPropagation();
        this.isMenuList = false;
        // console.log(e);
      }
    },
    inputAction() {
      this.activeName = false;
      this.fileVal = this.file.name;
      setTimeout(() => {
        this.$refs.inputEle.focus();
      }, 200);
    },
    openFile() {
      this.$emit("setFileGroupId", this.file.group_id, this.file.id);
    },
    blur() {
      this.activeName = true;
      this.fileVal && this.$emit("setFileName", this.file.id, this.fileVal);
    },
    handleFile(type) {
      switch (type) {
        case "move":
          this.$emit("setFileMoveId", this.file.id, "move");
          break;
        case "share":

          break;
        case "copy":
          this.$emit("setFileMoveId", this.file.id, "copy");
          break;
        case "del":
          this.fileVal && this.$emit("setDeleteFile", this.file.id);
          this.isMenuList = false;
          break;

        default:
          break;
      }
    },
    checkboxChange(val) {
      // console.log(val);
      this.$emit("setSelectFile", val, this.file.id);
    },
    imageRequire(type) {
      switch (type) {
        case "file": return require("@/assets/images/program/public_file.png");
        case "fileLock": return require("@/assets/images/program/public_file_lock.png");
        default:
          break;
      }
    }
  },
  watch: {
    isSelected: {
      handler(nVal) {
        this.fileChecked = nVal;
      }
    }
  },
  computed:{
    mPoint(){
      return `left: ${this.mousePoint.x}px; top: ${this.mousePoint.y}px;`
    }
  }
}
</script>

<style lang="scss" scoped>
.file-item {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  .file-img {
    width: 100%;
    height: calc(100% - 24px);
    position: relative;
    .m-img {
      height: 100%;
      // pointer-events: none;
      user-select: none;
    }
    .f-select {
      position: absolute;
      left: 2px;
      top: 0px;
      opacity: 0;
    }
    .f-select-a {
      opacity: 1;
    }
    .f-menu-list {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-30%, -30%);
      width: 60px;
      height: 90px;
      background-color: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      .f-m-l-item {
        width: 100%;
        text-align: center;
      }
      .f-m-l-item:hover {
        background-color: #edfbff;
        color: var(--theme-color-customized-1);
      }
    }
  }
  .file-img:hover .f-select {
    opacity: 1;
  }
  .file-title {
    width: calc(100% - 8px);
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    padding: 0px 4px;
    user-select: none;
  }
  .file-title-text {
    cursor: text;
  }
  .input-name {
    outline-style: none;
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 114px;
  }
}
</style>